import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { defer, finalize, Observable } from 'rxjs';
import { SpinnerService } from '../../services/loading/spinner.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {
  constructor(private spinnerService: SpinnerService) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    if (req.url.includes('maximoDesconto')) {
      return next.handle(req);
    }
    return defer(() => {
      this.spinnerService.busy();
      return next.handle(req).pipe(
        finalize(() => this.spinnerService.idle()),
      );
    });
  }
}
